import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TECH_SUPPORT_CENTER_MAILTO, TECH_SUPPORT_CENTER_NAME } from '../../constants/support-contact.constants';

@Component({
	selector: 'nha-403',
	styleUrls: ['403.component.scss'],
	templateUrl: './403.component.html',
	imports: [MatButtonModule, MatIconModule]
})
export class NHA403Component {
	readonly techSupportMailto = TECH_SUPPORT_CENTER_MAILTO;
	readonly techSupportName = TECH_SUPPORT_CENTER_NAME;

	goBack(): void {
		window.history.back();
	}
}
